import { Components, Theme } from '@mui/material/styles';

import { typography13RegularStyle } from 'src/legacy/components/Text';
import { red } from 'src/theme/colors';

const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: {
      textAlign: 'right',
      ...typography13RegularStyle,
      marginTop: 0,
      '&.MuiFormHelperText-root.Mui-error': {
        color: red,
      },
    },
    contained: {
      marginRight: 0,
    },
  },
};

export default MuiFormHelperText;
